import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { getOneClickPlantsState } from '../../selectors/one-click-plants.selector';

export class OneClickPlantDisabler extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(getOneClickPlantsState).pipe(
      filter(state => !!state),
      map(state => state.loading[this.mapItem['index']]),
    );
  }
}
